export const GoogleMapApiConfig = 'AIzaSyCXAx4mtb4qjNe1SHV5W_fqI0wbcpdCbWw';